module.exports = __webpack_public_path__ + "newsIco.png?52e65057b5d7c9892f0da372171909ad";